import React, { useContext, useMemo, useState } from 'react';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ManageAccountGrid from '../../../managementAccount/manageAccountGrid';
import DialogComp from '../../../../Core/Modal/dialogModal';
import { Grid } from '@material-ui/core';
import AddEditDashboard from './addEditDashboard';
import { EditButton } from '../../../../Core/FormInput/AppButton';
import AppsIcon from '@material-ui/icons/Apps';
import DashboardCategory from './DashboardCategory';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import CopyDashboardModal from './copyDashboardModal';
import DeleteIcon from '@material-ui/icons/Delete';
import { deleteDashboardNominalAccount, postMADashboard_SwapSequence } from '../../../../Core/Service/ManageAccount/manageAccountService';
import AppContext from '../../../../App/AppContext';
import { ArrowDownwardRounded, ArrowUpwardRounded } from '@material-ui/icons';
import ReactDOM from 'react-dom';
import ConfirmationModal from '../../../../Core/Controls/Dialog/ConfirmationModal';

let dashboardList = [];
const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Nominal Dashboard', active: true }
];

const baseColumns = [
    { field: 'action', title: 'Action', width: 120 },
    { field: 'maDashboardName', title: 'Name', width: 180 },
    { field: 'maDashboardHasBranch', title: 'Branch?', width: 85 },
    { field: 'maDashboardHasFranchise', title: 'Franchise?', width: 85 },
    { field: 'maDashboardHasPeriod', title: 'Period?', width: 85 },
    { field: 'maDashboardHasYear', title: 'Year?', width: 85 },
    { field: 'maDashboardBgColor', title: 'BG Colour', width: 85 },
    { field: 'maDashboardTextColor', title: 'Text Colour', width: 85 }
];

const MADashboard = () => {
    const { showToast } = useContext(AppContext);

    // const [dashboardList, setDashboardList] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [isPopupModal, setIsPopupModal] = useState(false);
    const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
    const [copyDashboardModalOpen, setCopyDashboardModalOpen] = useState(false);
    const [reloadFlag, setReloadFlag] = useState('');
    const [minSeq, setMinSeq] = useState(null);
    const [maxSeq, setMaxSeq] = useState(null);
    const [showWarning, setShowWarning] = useState(false);

    const openModal = () => setIsPopupModal(true);
    const closeModal = (isReload) => {
        setIsPopupModal(false);
        setSelectedRowData(null);
        if (isReload) setReloadFlag(new Date());
    };

    const handleDelete = async (data) => {
        setSelectedRowData(data);
        setShowWarning(true);

        // const res = await deleteDashboardNominalAccount(id);
        // if (res.success) {
        //     showToast(res.data.message);
        //     setReloadFlag(new Date());
        // }
    };
    const handleDeleteSubmit = async () => {
        const res = await deleteDashboardNominalAccount(selectedRowData.maDashboardID);
        if (res.success) {
            setShowWarning(false);
            showToast(res.data.message);
            setSelectedRowData(null);
            setReloadFlag(new Date());
        }
    };

    const handleMoveClick = async (record, direction) => {
        const index = dashboardList.findIndex((item) => item.maDashboardID === record.maDashboardID);

        if (index === -1) {
            showToast('Record not found in list');
            return;
        }

        const isAtTop = direction === 'up' && index === 0;
        const isAtBottom = direction === 'down' && index === dashboardList.length - 1;

        if (isAtTop || isAtBottom) {
            showToast('Cannot move item further in that direction');
            return;
        }

        const targetRecord = direction === 'up' ? dashboardList[index - 1] : dashboardList[index + 1];

        const res = await postMADashboard_SwapSequence(record.maDashboardID, targetRecord.maDashboardID);
        if (res.success) {
            showToast(res.data.message || 'Swapped successfully');
            setReloadFlag(new Date());
        } else {
            showToast(res.message || 'Swap failed');
        }
    };

    const renderEdit = (ev, row) => (
        <div style={{ display: 'flex', gap: '5px', justifyContent: 'flex-start', cursor: 'pointer' }}>
            <EditButton
                toolTipTitle="Edit Dashboard"
                onClick={() => {
                    setSelectedRowData(row);
                    setIsPopupModal(true);
                }}
            />
            <abbr title="Edit Categories">
                <AppsIcon
                    onClick={() => {
                        setSelectedRowData(row);
                        setIsCategoryModalOpen(true);
                    }}
                />
            </abbr>
            <abbr title="Copy">
                <FileCopyIcon
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        setSelectedRowData(row);
                        setCopyDashboardModalOpen(true);
                    }}
                />
            </abbr>
            <abbr title="Up">
                {row.maDashboardSequence !== minSeq ? (
                    <ArrowUpwardRounded fontSize="small" onClick={() => handleMoveClick(row, 'up')} />
                ) : (
                    <ArrowUpwardRounded fontSize="small" style={{ visibility: 'hidden' }} />
                )}
            </abbr>

            <abbr title="Down">
                {row.maDashboardSequence !== maxSeq ? (
                    <ArrowDownwardRounded fontSize="small" onClick={() => handleMoveClick(row, 'down')} />
                ) : (
                    <ArrowDownwardRounded fontSize="small" style={{ visibility: 'hidden' }} />
                )}
            </abbr>
            <abbr title="Delete">
                <DeleteIcon style={{ cursor: 'pointer', color: 'red' }} onClick={() => handleDelete(row)} />
            </abbr>
        </div>
    );

    const ColorCellRenderer = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center" justifyContent="center">
                <div
                    style={{
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'underline'
                    }}
                >
                    <input type="color" id="favcolor" name="favcolor" value={value} disabled />
                </div>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const cols = [...baseColumns];
        const actionCol = cols.find((col) => col.field === 'action');
        if (actionCol) actionCol.renderer = renderEdit;

        ['maDashboardBgColor', 'maDashboardTextColor'].forEach((field) => {
            const col = cols.find((col) => col.field === field);
            if (col) col.renderer = ColorCellRenderer;
        });

        return cols;
    }, [minSeq, maxSeq]);

    const onDataBinding = (e, record) => {
        if (record.length > 0) {
            const sequences = record.map((item) => item.maDashboardSequence);
            setMinSeq(Math.min(...sequences));
            setMaxSeq(Math.max(...sequences));
            dashboardList = record;
        }
    };

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <ManageAccountGrid
                columns={columns}
                getUrl="MADashboard"
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                btnTitle="Add New"
                onBtnClick={openModal}
                onDataBinding={(e, record) => onDataBinding(e, record)}
                isReload={reloadFlag}
            />

            {isPopupModal && (
                <DialogComp
                    title={selectedRowData?.maDashboardID ? 'Update Dashboard Details' : 'Add Dashboard Details'}
                    onClose={() => closeModal(false)}
                    maxWidth="sm"
                    fullWidth
                    overflow="auto"
                >
                    <AddEditDashboard onClose={closeModal} selectedRowData={selectedRowData} />
                </DialogComp>
            )}

            {isCategoryModalOpen && (
                <DialogComp
                    title={`Dashboard Categories - ${selectedRowData?.maDashboardName || ''}`}
                    onClose={() => {
                        setIsCategoryModalOpen(false);
                        setSelectedRowData(null);
                    }}
                    maxWidth="xl"
                    fullWidth
                    overflow
                >
                    <DashboardCategory
                        dashboardData={selectedRowData}
                        onClose={() => {
                            setIsCategoryModalOpen(false);
                            setSelectedRowData(null);
                        }}
                    />
                </DialogComp>
            )}

            {copyDashboardModalOpen && (
                <DialogComp
                    title={`Copy Dashboard - ${selectedRowData?.maDashboardName || ''}`}
                    onClose={() => {
                        setCopyDashboardModalOpen(false);
                        setSelectedRowData(null);
                    }}
                    maxWidth="sm"
                    fullWidth
                    overflow
                >
                    <CopyDashboardModal
                        selectedRowData={selectedRowData}
                        onClose={() => {
                            setCopyDashboardModalOpen(false);
                            setSelectedRowData(null);
                            setReloadFlag(new Date());
                        }}
                    />
                </DialogComp>
            )}
            {showWarning ? (
                <DialogComp
                    title="Warning"
                    onClose={() => {
                        setShowWarning(false);
                        setSelectedRowData(null);
                    }}
                    maxWidth="sm"
                    fullWidth
                >
                    <ConfirmationModal
                        message={`Are You sure you want to delete - ${selectedRowData.maDashboardName}`}
                        handleSubmit={handleDeleteSubmit}
                        handleCancel={() => {
                            setSelectedRowData(null);
                            setShowWarning(false);
                        }}
                    />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default MADashboard;
